import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Toolbar above the card grid: add button, search, select-all and a slot for
 * the per-page action buttons (export / import / template / bulk delete).
 */
const PageToolbar = ({
  addTo,
  onAdd,
  addLabel,
  searchValue,
  searchPlaceholder,
  onSearchChange,
  onSearchSubmit,
  selectAll,
  actions,
}) => {
  const { t } = useTranslation();

  const submit = (e) => {
    e.preventDefault();
    onSearchSubmit();
  };

  return (
    <div className="ad-toolbar">
      <div className="ad-toolbar-group">
        {/* A callback opens a dialog; `addTo` navigates instead. */}
        {onAdd && (
          <button type="button" className="ad-btn ad-btn-primary" onClick={onAdd}>
            <i className="fas fa-plus"></i>
            {addLabel || t('common.addNew')}
          </button>
        )}
        {!onAdd && addTo && (
          <Link to={addTo} className="ad-btn ad-btn-primary">
            <i className="fas fa-plus"></i>
            {addLabel || t('common.addNew')}
          </Link>
        )}

        {onSearchChange && (
          <form className="ad-search" onSubmit={submit} role="search">
            <input
              type="text"
              value={searchValue}
              placeholder={searchPlaceholder || t('common.search')}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <button type="submit" title={t('common.search')}>
              <i className="fas fa-search"></i>
            </button>
          </form>
        )}

        {selectAll && (
          <label className="ad-select-all">
            <input
              type="checkbox"
              className="ad-checkbox"
              checked={selectAll.checked}
              onChange={selectAll.onChange}
            />
            {selectAll.count > 0
              ? t('common.selectedCount', { count: selectAll.count })
              : t('common.selectAll')}
          </label>
        )}
      </div>

      {actions && <div className="ad-toolbar-group">{actions}</div>}
    </div>
  );
};

export default PageToolbar;
